import { render, staticRenderFns } from "./ContestDetailsModal.vue?vue&type=template&id=574ed2ae"
import script from "./ContestDetailsModal.vue?vue&type=script&lang=js"
export * from "./ContestDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports